import React from "react";
import PropTypes from "prop-types";
import { useLocation, Link } from "react-router-dom";
import { Alert, Box, Stack, CardActions, IconButton, Typography } from "@mui/material";
import { BsFileEarmarkMedicalFill } from "react-icons/bs";
import * as CONST from "../../Constants";
import AcknowledgeOutcome from "./AcknowledgeOutcome";

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  dateUpdated: PropTypes.bool.isRequired,
  outcomeMessage: PropTypes.string.isRequired,
  rejectedComment: PropTypes.array,
  needsResponse: PropTypes.bool.isRequired,
  appointmentDate: PropTypes.string,
  inReview: PropTypes.bool.isRequired,
  orderRequested: PropTypes.bool.isRequired,
  notConfirmed: PropTypes.bool.isRequired,
  order: PropTypes.string,
  responseStatus: PropTypes.string,
  id: PropTypes.number.isRequired,
  toggleMessages: PropTypes.object,
  response: PropTypes.object,
  responseSubmitted: PropTypes.object,
  questionSubmitted: PropTypes.object,
};

export const Status = (props) => {
  const location = useLocation();
  const [status, setStatus] = React.useState({
    message: null,
  });

  React.useEffect(() => {
    setStatus(
      props.status == "closed"
        ? CONST.STATUS_MESSAGE.COMPLETED
        : props.responseStatus == "Patient Requested Order" && !props.order
        ? { message: CONST.ORDER_REQUESTED_TEXT, severity: "success" }
        : props.responseStatus == "Rejected"
        ? { message: CONST.STATUS_MESSAGE.REJECTED, severity: "success" }
        : props.responseStatus == "Patient Reported Completed"
        ? { message: CONST.STATUS_MESSAGE.REPORTED_COMPLETED, severity: "success" }
        : props.responseStatus == "Patient Reported Completed with Document"
        ? { message: CONST.STATUS_MESSAGE.REPORTED_COMPLETED_WITH_DOCUMENT, severity: "success" }
        : props.status == "follow_up"
        ? { message: CONST.STATUS_MESSAGE.FOLLOW_UP, severity: "error" }
        : props.status == "past_due"
        ? { message: CONST.STATUS_MESSAGE.PAST_DUE, severity: "error" }
        : (props.status == "reminder" || props.status == "confirmation") &&
          ((!props.responseStatus && props.dateUpdated) || props.needsResponse)
        ? { message: CONST.STATUS_MESSAGE.CONFIRMATION, severity: "error" }
        : props.responseStatus &&
          props.responseStatus == "Confirmed" &&
          (props.status == "reminder" || props.status == "confirmation")
        ? props.appointmentDate
          ? { message: CONST.STATUS_MESSAGE.CONFIRMED_APPOINTMENT, severity: "success" }
          : { message: CONST.STATUS_MESSAGE.CONFIRMED_UPDATED_DUE_DATE, severity: "success" }
        :  props.toggleMessages
        ? { message: CONST.STATUS_MESSAGE.QUESTION_SUBMITTED, severity: "success"}
        : null
    );
  }, [props]);

  let reportedCompleted = props.responseStatus && props.responseStatus.match("Patient Reported Completed") &&
    props.responseStatus.match("Patient Reported Completed").length > 0;
  return (
    <>
      {props.outcomeMessage && (
        <AcknowledgeOutcome
          dispatch={props.dispatch}
          outcomeMessage={props.outcomeMessage}
          acknowledgedAfterOutcome={props.acknowledgedAfterOutcome}
          id={props.id}
          response={props.response}
        />
      )}

      {(props.order || props.order_not_available_reason) && (
        <CardActions disableSpacing className={"bt "} id="icon-actions">
          <Stack direction="row" spacing={1}>
            <Box width="97%">
              <Alert className="statusMessage" severity="info">
                {props.order && !props.orderRequested && CONST.ORDER_UPLOADED_NO_REQUEST}
                {props.order && props.orderRequested && CONST.ORDER_REQUEST_RECIEVED_TEXT}
                {
                  props.order_not_available_reason && !props.order && (<>
                    An order is not available for the following reason: { props.order_not_available_reason }
                    </>)
                }
              </Alert>
            </Box>
            {props.order && (
              <IconButton
                className="card-button"
                aria-label="view order document"
                sx={{ marginLeft: "auto" }}
              >
                <a
                  href={props.order }
                  className="no-style "
                  rel="noopener noreferrer"
                >
                  <BsFileEarmarkMedicalFill />
                </a>
              </IconButton>
            )}
          </Stack>
        </CardActions>
      )}
      {(!props.outcomeMessage || props.toggleMessages) && (
        <>
          {status && status.message && (
            <CardActions disableSpacing id="icon-actions" className="bt">
              <Stack direction="row" spacing={1}>
                <Box width={props.toggleMessages ? "97%" : "100%"}>
                  <Alert severity={status.severity} className="statusMessage">
                    <b>{status.message}</b>
                    <Typography variant="body1" fontWeight={400}>
                      <small>
                        {props.questionSubmitted && (
                          <>
                            <b>"{ props.questionSubmitted.text }"</b>
                            <br />
                            { CONST.STATUS_MESSAGE.QUESTION_UPDATE }
                            <br />
                          </>
                        )}
                        {reportedCompleted == true && props.responseSubmitted && (
                          <>
                            { CONST.STATUS_MESSAGE.REPORTED_COMPLETED_TEXT}
                            <br />
                            Completed On Date: <b>{props.responseSubmitted.completed_on_date && <>
                              { props.responseSubmitted.completed_on_date }
                              </>
                            }</b>
                            <br />
                            Provider: <b>{ props.responseSubmitted.attending_provider }</b>
                            <br />
                            <i>Responded on { new Date(props.responseSubmitted.created_at).toDateString([], {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                              })
                            }</i>
                            <br />
                          </>
                        )}
                        {props.responseStatus == "Rejected" && props.rejectedComment && (
                          <>
                            {props.rejectedComment.comment ? (
                              <>
                                {CONST.STATUS_MESSAGE.REJECTED_COMMENT}
                                <br />
                                <i>
                                  <b>{props.rejectedComment.comment} </b>
                                </i>
                              </>
                            ) : (
                              CONST.STATUS_MESSAGE.REJECTED_NO_COMMENT
                            )}
                            {new Date(props.rejectedComment.created_at).toLocaleDateString([], {
                              hour: "numeric",
                              minute: "numeric",
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })}
                            <br />
                            { CONST.STATUS_MESSAGE.REJECTED_UPDATE }
                            <br />
                          </>
                        )}
                      </small>
                    </Typography>
                  </Alert>
                </Box>
                {props.toggleMessages}
              </Stack>
            </CardActions>
          )}
        </>
      )}
    </>
  );
};
Status.prototype = propTypes;
export default Status;
